import React, {JSX} from 'react';
import styles from './PropertyRow.module.scss';
import {Button, Icon, IconData, Link, Text} from '@gravity-ui/uikit';
import classNames from 'classnames';

interface PropertyRowProps {
  property: string;
  value: string | React.ReactNode | JSX.Element;
  icon?: IconData;
  onclick?: () => void;
  isLink?: boolean;
  isHtml?: boolean;
  className?: string;
}

export const PropertyRow = ({property, value, icon, onclick, isLink, isHtml, className}: PropertyRowProps) => {
  return (
    <div className={styles.root}>
      <Text variant={'subheader-1'} className={classNames(styles.property, className)}>
        {property}
      </Text>
      <div className={styles.valueContainer}>
        {isLink ? (
          <Link href={value as string} target="_blank" rel="noopener noreferrer" className={styles.link}>
            <Text variant={'body-1'}>{value}</Text>
          </Link>
        ) : isHtml && typeof value === 'string' ? (
          <div dangerouslySetInnerHTML={{__html: value}} />
        ) : (
          <Text variant={'body-1'}>{value}</Text>
        )}
        {icon && (
          <Button onClick={onclick} view={'normal'} size={'s'}>
            <Icon data={icon} size={16} />
          </Button>
        )}
      </div>
    </div>
  );
};
